// Canonical tab id → display label. Single source of truth so any UI that
// needs to *name* a tab (nav bar, "View in X" deep-link labels, etc.) stays
// in sync automatically when a tab gets relabelled.
export const TAB_LABELS = {
  home: 'Home',
  logistics: 'Itinerary',
  bucketlist: 'Shortlist',
  dayplanner: 'Schedule',
  expenses: 'Expenses',
} as const;

export type NavTabId = keyof typeof TAB_LABELS;
